import { PlatformEnvironment } from '@mews/enums';

export const getRequestCredentials = (environment?: PlatformEnvironment | string): RequestCredentials | undefined =>
    environment === PlatformEnvironment.Quality ? 'same-origin' : undefined;
